import React from "react";

import Text from "src/components/text";
import { getAuthorName } from "src/services/reports.service";
import { formatTimespent } from "src/services/reports.service";

import { Asset } from "src/types/assets";
import { Analytics } from "src/types/reports";

import _ from "lodash";
import styles from "./assetCardList.module.scss";

const DefaultAssetIcon = "/images/defaultIcons/default_asset.jpg";

export interface AssetCardListProps {
  item: {
    asset: Asset;
    analytics: Analytics;
  };
  columnCount: number;
}

export const AssetCardList: React.FC<AssetCardListProps> = ({
  item,
  columnCount,
}) => {
  const { asset, analytics } = item;

  return (
    <div className={styles.tableRow}>
      <div className={styles.tableDataContainer}>
        <img
          src={asset?.icon?.thumbnail || DefaultAssetIcon}
          alt={asset.name}
          className={styles.thumbnailIcon}
        />
        <a
          href={`/assets/${asset.id}?source=reports`}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.linkWrapper}
        >
          <div className={styles.rightData}>
            <div className={styles.tableDataTitle}>
              <Text lines={1} className={styles.title} text={asset?.name} />
            </div>
            <span className={styles.metricsData}>
              <span className={styles.name}>
                Added:{" "}
                {asset?.createdDate && new Date(asset.createdDate).toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                })}
              </span>
            </span>
          </div>
        </a>
      </div>
      <div
        className={styles.analyticsContainer}
        style={{
          gridTemplateColumns: `repeat(${columnCount}, minmax(0, 1fr))`,
        }}
      >
        <span className={styles.tableDataViews}>
          <Text
            className={styles.author}
            lines={1}
            text={asset.author ? getAuthorName(asset.author) : ""}
          />
        </span>
        <div className={styles.tableDataViews}>{analytics.views}</div>
        <div className={styles.tableDataTime}>
          {formatTimespent(_.get(analytics, "avgTimeSpent", 0))}
        </div>
        <div className={styles.tableDataViews}>{analytics.downloads}</div>
        <div className={styles.tableDataShares}>{analytics.shares}</div>
      </div>
    </div>
  );
};
